import NatureOfBusiness from './NatureOfBusiness';

export default NatureOfBusiness;
